import { useContext } from "react";
import { AuthContext } from "./AuthProvider";

// Clean, single-purpose hook file to satisfy Vite Fast Refresh
export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    console.warn("[Auth] useAuth must be used within an AuthProvider");
    return {
      user: null,
      profile: null,
      loading: false,
      error: new Error("AuthProvider is missing"),
      signIn: async () => ({ message: "AuthProvider not found" }),
      logout: async () => {},
    };
  }

  return context;
}
